(()=>{
  const positionWave=(root)=>{
    const strip=root.querySelector('.ak-hero-products');
    if(!strip)return;
    const left=strip.offsetLeft;
    const right=Math.max(0,root.clientWidth-(strip.offsetLeft+strip.offsetWidth));
    const top=strip.offsetTop+(strip.offsetHeight*.14);
    const height=(strip.offsetHeight*.86)+54;
    root.style.setProperty('--ak-strip-left',`${Math.round(left)}px`);
    root.style.setProperty('--ak-strip-right',`${Math.round(right)}px`);
    root.style.setProperty('--ak-strip-backdrop-top',`${Math.round(top)}px`);
    root.style.setProperty('--ak-strip-backdrop-height',`${Math.round(height)}px`);
  };

  const init=(root)=>{
    if(!root||root.dataset.akWaveReady==='true')return;
    root.dataset.akWaveReady='true';
    const strip=root.querySelector('.ak-hero-products');
    if(!strip)return;
    const update=()=>requestAnimationFrame(()=>positionWave(root));
    update();
    window.addEventListener('resize',update,{passive:true});
    if('ResizeObserver' in window){
      const ro=new ResizeObserver(update);
      ro.observe(root);
      ro.observe(strip);
    }
    if('MutationObserver' in window){
      const mo=new MutationObserver(update);
      mo.observe(strip,{childList:true});
    }
  };

  const initAll=(scope=document)=>scope.querySelectorAll?.('[data-ak-hero-focus]').forEach(init);
  document.addEventListener('DOMContentLoaded',()=>initAll(document));
  document.addEventListener('shopify:section:load',event=>initAll(event.target));
})();
